import { useQuery } from "react-query";
import { Profile } from "../models/profile";
import { getInitializer } from "../services/InitializerService";

export function useInitializer() {
  return useQuery<Profile, Error>(["initializer"], () => getInitializer());
}
